/* DoubleClick/gtag conditional no-op in SSO */

function hasSSOQueryParam() {
  try {
    const params = new URLSearchParams(window.location.search)
    const sso = params.get('sso')
    return sso === '1' || sso === 'true'
  } catch (e) {
    return false
  }
}

function isSSO(store) {
  try {
    if (store && store.getters && store.getters.isSSO) return true
    const persisted = localStorage.getItem('isSSO')
    if (persisted === '1') return true
  } catch (e) { /* noop */ }
  return hasSSOQueryParam()
}

export function initGtag(store) {
  if (!isSSO(store)) return

  // dataLayer/gtag stubs
  if (!window.dataLayer) {
    window.dataLayer = []
  }
  if (!window.gtag) {
    window.gtag = function () {
      // no-op in SSO; keep API shape
      window.dataLayer.push(arguments)
    }
  }

  // googletag pubads stub
  if (!window.googletag) {
    window.googletag = { cmd: [], pubads: () => ({}) }
  }

  // adsbygoogle stub
  if (!window.adsbygoogle) {
    try {
      window.adsbygoogle = []
    } catch (e) { /* ignore */ }
  }
}
